import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { 
  Button, 
  IconButton, 
  Typography, 
  TextField } from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SearchTextField from "../../components/SearchTextField/SearchTextField";
import MealTable from "../../components/BasicTable/BasicTable";
import Pagination from "../../components/Pagination/Pagination";
import routes from "../../react_routes_enum";
import Spinner from "../../components/Spinner/Spinner";
import NotesIcon from "../../assest/images/notes.png";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import Listing from '../../components/listing/Listing';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LoaderIcon from "../../components/loader/Loader";
import { logout, reset } from "../../redux/auth/authSlice";
import {
  getUniversities,
  setUniversityById,
  getUniversityByToken,
  setUniversityByIdData,
  universityStatusUpdate
} from "../../redux/universities/universitySlice";
import { toast } from "react-toastify";
import { 
  getCoaching, 
  coachingStatusUpdate,
  getCoachingByToken,
  setCoachingByIdData
} from "../../redux/coaching/coachingSlice";

let reviewBody = {
  id: "",
  request_status: "review",
  changes: [],
  information_check: 0,
  from: "review",
}

const Registration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { 
    isLoading, 
    isError, 
    totalCount, 
    message, 
    searchText,
    universityData,
  } = useSelector((state) => state.university);
  const { 
    isCLoading,
    isCError,
    coachingData } = useSelector((state) => state.coaching);
  // Pagination Required parameters
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [page, setPage] = useState(0);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isRejectModel, setIsRejectModel] = useState(false);
  const [isRequestModel, setIsRequestModel] = useState(false);
  const [isListing, setIsListing] = useState(false);
  const [reviewFormBody, setReviewFormBody] = useState(reviewBody);
  const [btnLoader, setBtnLoader] = useState(false);
  const [isOnApprove, setIsOnApprove] = useState(false);
  const [instId, setInstId] = useState("");
  const [actionFrom, setActionFrom] = useState("");

  const colR = ["SNo", "Name of University", "city", "Full Address", "Website Link", "actions"];
  const colR2 = ["SNo", "Name of Coaching Center", "city", "Full Address", "Website Link", "actions"];
  const { type } = useSelector(
    (state) => state.university
  );

  useEffect(() => {
    let res = null;
    if(type === "University") (res = dispatch(getUniversities({ limit, offset, searchText: "", request_status: "registration" })));
    if(type === "Coaching") (res = dispatch(getCoaching({ limit, offset, searchText: "", request_status: "registration" })));
    res?.then((r) => {
      if(r?.payload?.message.toLowerCase() === "unauthorized" || 
        r?.payload?.message === "Session Expired"){
        toast.error("Session expired, please login again");
        dispatch(logout());
        dispatch(reset());
        navigate(routes.LOGIN);
      }
    })
  }, [limit, offset, type]);

  const resetStateForPaginationOfDifferentView = () => {
    setLimit(10);
    setOffset(0);
    setPage(0);
  };

  const handleSearchText = (e) => {
    resetStateForPaginationOfDifferentView();
    if (limit === 10 && offset === 0) {
      let res = null;
      type === "University" ? (res = dispatch(getUniversities({ limit, offset, searchText, request_status: "registration" }))) :
        (res = dispatch(getCoaching({ limit, offset, searchText, request_status: "registration" })))
      
      res?.then((r) => {
        if(r?.payload?.message.toLowerCase() === "unauthorized" || 
          r?.payload?.message === "Session Expired"){
          toast.error("Session expired, please login again");
          dispatch(logout());
          dispatch(reset());
          navigate(routes.LOGIN);
        }
      })
    }
  };

  if (isLoading || isCLoading) return <Spinner />;
  if (isError || isCError) return <h1>{message}</h1>;
  const handleClose = () => {
    setIsDialogOpen(false);
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if(type === "University"){
      setBtnLoader(true);
      const res = dispatch(universityStatusUpdate(reviewFormBody));
      res.then((r) => {
        setBtnLoader(false);
        if(r.payload.statusCode === 200){
          toast.success("University Changes Request Submitted");
          dispatch(getUniversities({ limit, offset, searchText, request_status: "registration" }))
          setIsDialogOpen(false);
        }else{
          if(r?.payload?.message.toLowerCase() === "unauthorized" || 
            r?.payload?.message === "Session Expired"){
            toast.error("Session expired, please login again");
            dispatch(logout());
            dispatch(reset());
            navigate(routes.LOGIN);
            return;
          }
          toast.error(r?.payload?.message);
        }
      })
    }else{
      setBtnLoader(true);
      const res = dispatch(coachingStatusUpdate(reviewFormBody));
      res.then((r) => {
        setBtnLoader(false);
        if(r.payload.statusCode === 200){
          toast.success("Coaching Changes Request Submitted");
          dispatch(getCoaching({ limit, offset, searchText, request_status: "registration" }))
          setIsDialogOpen(false);
        }else{
          if(r?.payload?.message.toLowerCase() === "unauthorized" || 
            r?.payload?.message === "Session Expired"){
            toast.error("Session expired, please login again");
            dispatch(logout());
            dispatch(reset());
            navigate(routes.LOGIN);
            return;
          }
          toast.error(r?.payload?.message);
        }
      })
    }
  }

  const approveClicked = (id, from) => {
    if(type === "University"){
      const res = dispatch(universityStatusUpdate({id, from, request_status: "review", changes: ["Under Review"]}));
        res.then((r) => {
          if(r.payload.statusCode === 200){
            toast.success("University Sent In Review");
            dispatch(getUniversities({ limit, offset, searchText, request_status: "registration" }))
            setIsDialogOpen(false);
          }else{
            if(r?.payload?.message.toLowerCase() === "unauthorized" || 
              r?.payload?.message === "Session Expired"){
              toast.error("Session expired, please login again");
              dispatch(logout());
              dispatch(reset());
              navigate(routes.LOGIN);
              return;
            }
            toast.error(r?.payload?.message);
          }
      })
    }else{
      const res = dispatch(coachingStatusUpdate({id, from, request_status: 'review', changes: ["Under Review"]}));
      res.then((r) => {
        if(r.payload.statusCode === 200){
          toast.success("Coaching Sent In Review");
          dispatch(getCoaching({ limit, offset, searchText, request_status: "registration" }))
          setIsDialogOpen(false);
        }else{
          if(r?.payload?.message.toLowerCase() === "unauthorized" || 
            r?.payload?.message === "Session Expired"){
            toast.error("Session expired, please login again");
            dispatch(logout());
            dispatch(reset());
            navigate(routes.LOGIN);
            return;
          }
          toast.error(r?.payload?.message);
        }
      })
    }
  }
  const addListing = () => {
    dispatch(setUniversityByIdData(null));
    dispatch(setCoachingByIdData(null));
    
    if(type === "University"){
      if(!localStorage.getItem("new_institute_token")){
        setIsListing(true);
      }else{
        let res = dispatch(getUniversityByToken());
        res.then((r) => {
          if(r.payload.statusCode === 200){
            if(!r?.payload?.data?.information_check){
              navigate(routes.INFORMATION);
              return;
            }
            if(!r?.payload?.data?.uploads_check){
              navigate(routes.UPLOAD);
              return;
            }
            if(!r?.payload?.data?.courses_offered_check){
              navigate(routes.COURSE);
              return;
            }
            if(!r?.payload?.data?.placement_records_check){
              navigate(routes.PLACEMENT_RECORD);
              return;
            }
          }else{
            if(r?.payload?.message.toLowerCase() === "unauthorized" || 
              r?.payload?.message === "Session Expired"){
              toast.error("Session expired, please login again");
              dispatch(logout());
              dispatch(reset());
              navigate(routes.LOGIN);
              return;
            }
            toast.error(r?.payload?.message);
          }
        })
      }
    }else{
      if(!localStorage.getItem("new_coaching_token")){
        setIsListing(true)
      }else{
        let res = dispatch(getCoachingByToken());
        res.then((r) => {
          if(r.payload.statusCode === 200){
            if(!r?.payload?.data?.information_check){
              navigate(routes.COACHING_INFORMATION);
              return;
            }
            if(!r?.payload?.data?.uploads_check){
              navigate(routes.COACHING_UPLOAD);
              return;
            }
            if(!r?.payload?.data?.faculties_details_check){
              navigate(routes.COACHING_COURSE);
              return;
            }
          }else{
            if(r?.payload?.message.toLowerCase() === "unauthorized" || 
              r?.payload?.message === "Session Expired"){
              toast.error("Session expired, please login again");
              dispatch(logout());
              dispatch(reset());
              navigate(routes.LOGIN);
              return;
            }
            toast.error(r?.payload?.message);
          }
        })
      }
    }
  } 
  const openApproveAlert = (id, from, isUpdated) => {
    if(!isUpdated){
      toast.error("Data not updated yet");
      return;
    }
    setIsDialogOpen(true);
    setIsOnApprove(true);
    setInstId(id);
    setActionFrom(from);
  }
  return (
    <>
      <Dialog maxWidth={isOnApprove ? "xs" : "md"} 
        open={isDialogOpen} 
        onClose={handleClose} 
        fullWidth>
        {!isOnApprove ?
        <form onSubmit={handleSubmit} style={{padding: '0 20% 2% 20%'}}>
          <DialogContent>
            <Typography component="h2" variant="h2" 
              sx={{
                color: '#D60000',
                textAlign: 'center',
                fontSize: '28px',
                fontWeight: 'bold',
                margin: '24px 0 48px'}}>
              {isRequestModel ? 'Request changes' : 'Rejected'}
            </Typography>
            <div style={{
              width: '100%',
              border: '1px solid #000000',
              height: '290px'
            }} className="reject-buttons">
              <TextField fullWidth 
                placeholder="Write a reason for rejection" 
                variant="outlined"
                multiline
                rows={7}
                sx={{border: 'none'}}
                required
                onChange={(e) => setReviewFormBody({
                  ...reviewFormBody, changes: e.target.value.split("\n")
                })}/>
              <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                padding: '36px 12px 0 0'
              }}>
                {!isRequestModel && <Button 
                  variant="contained" 
                  type="submit" 
                  sx={{
                    backgroundColor: '#DC0707',
                    textTransform: 'capitalize',
                    fontSize: '20px',
                    width: '170px',
                    marginRight: '12px',
                    borderRadius: '8px'
                    }}>
                  {'Block'}
                </Button>}
                <Button 
                  variant="contained" 
                  type="submit" 
                  disabled={btnLoader}
                  sx={{
                    backgroundColor: btnLoader ? 'var(--disable-color)' : '#07AB35',
                    textTransform: 'capitalize',
                    fontSize: '20px',
                    width: '140px',
                    marginLeft: '12px',
                    borderRadius: '8px'
                    }}>
                  {btnLoader ? <LoaderIcon /> :'Submit'}
                </Button>
              </div>
            </div>
          </DialogContent>
        </form> :
        <div>
          <Typography component="p" variant="p" 
            sx={{
              textAlign: 'center',
              fontWeight: 'bold',
              margin: '28px 0 48px'}}>
            Are you sure you want to<br/> approve the application form?
          </Typography>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'row-reverse',
            padding: '0px 16px 28px 16px'
          }}>
            <Button onClick={() => {setIsDialogOpen(false)}} variant="outlined" sx={{
              textTransform: 'capitalize'
            }}>
              Cancel
            </Button>
            <Button onClick={() => {approveClicked(instId, actionFrom)}} variant="contained" sx={{
              backgroundColor: 'var(--primary-color)',
              width: '84px',
              marginRight: '12px',
              textTransform: 'capitalize'
            }}>
              Yes
            </Button>
          </div>
        </div>}
      </Dialog>
      {isListing ?
        <div>
            <Listing 
              from={type}
              back={() => {setIsListing(false)}}/>
        </div>:
        <div style={{marginTop: '3%'}}>
        <SearchTextField
          searchText={searchText}
          handleSearchText={handleSearchText}
          fromWhere="meal"
        />
        <div className="pagination-addPost">
          <Pagination
            totalCount={totalCount}
            limit={limit}
            page={page}
            changeLimit={setLimit}
            changeOffset={setOffset}
            changePage={setPage}
          />
        </div>
        <div style={{
          display: 'flex', 
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          marginTop: '12px',
          }}>
          <Button variant="contained" onClick={() => {addListing()}}
          sx={{
              backgroundColor: '#F69220',
              textTransform: 'capitalize',
              borderRadius: '8px'
              }}>
          <ControlPointIcon sx={{marginRight: '4px'}} />
              Add Listing
          </Button>
        </div>
        <MealTable
          columns={type=== "University" ? colR : colR2}
          where="recipes"
          rows={type=== "University" ? (universityData && universityData?.map((item) => {
            const res = {
              ...item,
              actions: (
                <div>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <IconButton
                      color="inherit"
                      edge="start"
                      onClick={() => {
                        dispatch(setUniversityById(item._id));
                      }}
                    >
                      <Link to={routes.DETAILS}>
                        <VisibilityIcon sx={{color: '#3C1CDE'}} />
                        <Typography component="p" variant="p" 
                          sx={{
                            color: '#3C1CDE',
                            fontSize: '18px',
                            fontWeight: 'bold'
                            }}>
                          View
                        </Typography>
                      </Link>
                    </IconButton>
                    <IconButton
                      color="inherit"
                      edge="start"
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '0 8px'
                      }}
                      onClick={() => openApproveAlert(
                        item._id, 
                        "registration", 
                        (item.information_check &&
                          item.uploads_check &&
                          item.courses_offered_check &&
                          item.placement_records_check
                          )
                        )}
                    >
                      <CheckCircleOutlineIcon sx={{color: '#07AB35'}} />
                      <Typography component="p" variant="p" 
                        sx={{
                          color: '#07AB35',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          marginTop: '6px'
                          }}>
                        Approved
                      </Typography>
                    </IconButton>
                    <IconButton
                      color="inherit"
                      edge="start"
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                      onClick={() => {
                        setIsRejectModel(false);
                        setIsDialogOpen(true);
                        setIsRequestModel(true);
                        setIsOnApprove(false);
                        setReviewFormBody({...reviewFormBody, id: item._id})
                      }}
                    >
                      <img src={NotesIcon} alt="notes_logo" width="20" />
                      <Typography component="p" variant="p" 
                        sx={{
                          color: '#ECAB2D',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          marginTop: '9px'
                          }}>
                        Requested
                      </Typography>
                    </IconButton>
                  </div>
                </div>
              )
            };
            return res;
          })) :
          (coachingData && coachingData?.map((item) => {
            const res = {
              ...item,
              actions: (
                <div>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <IconButton
                      color="inherit"
                      edge="start"
                      onClick={() => {
                        dispatch(setUniversityById(item._id));
                      }}
                    >
                      <Link to={routes.DETAILS}>
                        <VisibilityIcon sx={{color: '#3C1CDE'}} />
                        <Typography component="p" variant="p" 
                          sx={{
                            color: '#3C1CDE',
                            fontSize: '18px',
                            fontWeight: 'bold'
                            }}>
                          View
                        </Typography>
                      </Link>
                    </IconButton>
                    <IconButton
                      color="inherit"
                      edge="start"
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '0 8px'
                      }}
                      onClick={() => openApproveAlert(item._id, "registration", 
                      (item.information_check &&
                        item.uploads_check &&
                        item.faculties_details_check)
                      )}
                    >
                      <CheckCircleOutlineIcon sx={{color: '#07AB35'}} />
                      <Typography component="p" variant="p" 
                        sx={{
                          color: '#07AB35',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          marginTop: '6px'
                          }}>
                        Approved
                      </Typography>
                    </IconButton>
                    <IconButton
                      color="inherit"
                      edge="start"
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                      onClick={() => {
                        setIsRejectModel(false);
                        setIsDialogOpen(true);
                        setIsRequestModel(true);
                        setIsOnApprove(false);
                        setReviewFormBody({...reviewFormBody, id: item._id})
                      }}
                    >
                      <img src={NotesIcon} alt="notes_logo" width="20" />
                      <Typography component="p" variant="p" 
                        sx={{
                          color: '#ECAB2D',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          marginTop: '9px'
                          }}>
                        Requested
                      </Typography>
                    </IconButton>
                  </div>
                </div>
              )
            };
            return res;
          }))
        }
        />
        </div>
        }
    </>
  );
};

export default Registration;
